const paddings = {
  xxxs: 6,
  xxs: 9,
  xs: 12,
  sm: 18,
  md: 24,
  lg: 30,
  xl: 36,
  xxl: 42,
  xxxl: 48,
  xxxxl: 60
}, commonSizesByElement = {
  common: paddings,
  typography: {
    xxs: void 0,
    xs: 10,
    sm: 12,
    md: 14,
    lg: 16,
    xl: 18,
    xxl: 20
  },
  control: {
    xxs: 24,
    xs: 30,
    sm: 36,
    md: 42,
    lg: 48,
    xl: 54,
    xxl: 60
  },
  icon: {
    xxs: void 0,
    xs: 12,
    sm: 18,
    md: 24,
    lg: 36,
    xl: 42,
    xxl: 48
  },
  dropdown: {
    xxs: void 0,
    xs: void 0,
    sm: 216,
    md: 282,
    lg: 342,
    xl: void 0,
    xxl: void 0
  },
  modal: {
    xxs: 300,
    xs: 330,
    sm: 400,
    md: 480,
    lg: 560,
    xl: 640,
    xxl: 720,
    xxxl: 800
  },
  bullet: {
    xxs: 6,
    xs: 9,
    sm: 12,
    md: 18,
    lg: void 0,
    xl: void 0,
    xxl: void 0
  },
  avatar: {
    xxs: void 0,
    xs: 24,
    sm: 42,
    md: 54,
    lg: 72,
    xl: 102,
    xxl: void 0
  }
};
export {
  commonSizesByElement
};
//# sourceMappingURL=dimentions.js.map
